<template>
<div >
  <template v-for='person in filteredPeople' >
    <person-list-item
      v-if='person'
      @selected='$emit("selected", person)'
      @edit='$emit("selected", person)'
      :with-edit='withEdit'
      :person='person'
      :key='person.id' >
    </person-list-item>
    <v-divider
      v-if='person'
      :key='`div-${person.id}`' ></v-divider>
  </template>
  <v-layout>
    <v-flex
      v-if='filteredPeople && filteredPeople.length === 0 && request && request.loading'
      xs12 class='text-xs-center' >
      <v-progress-circular
        size='20' width="2"
        indeterminate color='amber' ></v-progress-circular>
      {{ $t("notices.searching") }}
    </v-flex>
    <v-flex
      v-if='filteredPeople && filteredPeople.length === 0 && request && !request.loading'
      xs12 class='text-xs-center' >
      {{ $t("notices.noresults") }}
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import PersonListItem from '@/components/medicalaid/PersonListItem'
export default {
  name: 'PersonList',
  components: {PersonListItem},
  props: {
    searchText: { type: String, default: '' },
    people: { type: Array, default: () => { return [] } },
    withEdit: { type: Boolean, default: false },
    request: { type: Object }
  },
  data () {
    return {}
  },
  computed: {
    filteredPeople () {
      if (!this.people) { return [] }
      if (this.searchText && this.searchText.length > 1) {
        return this.people.filter((item) => {
          let index = `${item.title} ${item.first_name} ${item.last_name} ${item.email} ${item.cell_phone} ${item.nickname}`.toLowerCase()
          return (index.indexOf(this.searchText) !== -1)
        })
      }
      return this.people
    }
  },
  i18n: {
    messages: {
      en: {
        notices: {
          searching: 'Searching on the server ..',
          noresults: 'No contacts found that match your query'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PersonList.vue?2fd545b8